/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DashboardAuthControllerGetCurrentUser$Params {
}

export function dashboardAuthControllerGetCurrentUser(http: HttpClient, rootUrl: string, params?: DashboardAuthControllerGetCurrentUser$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'id'?: string;
'email'?: string;
'fullName'?: string;
'company'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, dashboardAuthControllerGetCurrentUser.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'id'?: string;
      'email'?: string;
      'fullName'?: string;
      'company'?: string;
      }>;
    })
  );
}

dashboardAuthControllerGetCurrentUser.PATH = '/dashboard/auth/user';
